<template>
  <v-footer v-if="company" style="width: 150px;" height="auto" color="transparent" fixed>
    <v-expand-transition>
      <div>
        <v-card v-if="show_form" width="350">
          <v-card-title style="cursor: pointer" @click="show_form = false">
            <h4 class="primary--text">{{ $t("support_form/title") }}</h4>
            <v-spacer></v-spacer>
            <v-icon>$vuetify.icons.rms_debit_tree</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="greyDarken3--text">
              {{ $t("support_form/intro_text") }}
            </div>
          </v-card-text>
          <v-card-text class="pb-0">
            <v-form ref="supportForm">
              <v-text-field
                v-model="form.name"
                outline
                :label="$t('support_form/name')"
                :rules="[rules.required]"
                color="secondary"
              ></v-text-field>
              <v-text-field
                v-model="form.email"
                outline
                :label="$t('support_form/email')"
                :rules="[rules.required, rules.email]"
                color="secondary"
              ></v-text-field>
              <v-textarea
                v-model="form.message"
                outline
                :label="$t('support_form/message')"
                :rules="[rules.required]"
                color="secondary"
              ></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-3 pt-0">
            <v-btn outline color="primary" @click="sendSupportRequest">{{
              $t("support_form/submit_btn")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-expand-transition>
    <v-expand-transition>
      <v-btn
        v-if="!show_form"
        small
        @click="show_form = true"
        color="blue darken-2"
        dark
      >
        <small>{{ $t("support_form/btn") }}</small>
      </v-btn>
    </v-expand-transition>
  </v-footer>
</template>
<script>
import rules from "@/validation";
import { mapState } from "vuex";

export default {
  name: "SupportForm",
  data() {
    return {
      form: {
        name: "",
        email: "",
        message: "",
      },
      show_form: false,
      rules,
    };
  },
  computed: {
    ...mapState({
      company: (state) => state.company.company,
    }),
  },
  methods: {
    async sendSupportRequest() {
      try {
        if (!this.$refs.supportForm.validate()) {
          return false;
        }
        this.form.company_id = this.company.id;
        this.form.refer_page =
          window.location.origin + this.$router.currentRoute.fullPath;

        await this.$store.dispatch("consumer/sendSupportRequest", this.form);
        this.$store.dispatch("app/showMessage", {
          message: this.$t("support_form/get_bact_to_you"),
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      } finally {
        this.show_form = false;
      }
    },
  },
};
</script>
